import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { AddTypeBO, AddNoteBO } from './employee-notes.model';

@Injectable({
  providedIn: 'root'
})

export class EmployeeNotesService {

  constructor(private http: HttpClient, public errorService: ErrorService) {

  }
  //   ..................................................TYPE.....................................................................

  getLov(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdatetype(saveList: AddTypeBO): Observable<any> {
    let url = "api/NoteType/SaveNoteType";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  delete(params: URLSearchParams) {
    let url = "api/TypeList/DeleteTypeList?";
    return this.http.delete<any>(url + params).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  // ......................................................notes.......................................................................

  saveupdatenote(Add: AddNoteBO): Observable<any> {
    let url = "api/EmployeeNote/SaveEmpNote?";
    return this.http.post<any>(url, Add, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  }

  updatenote(Add: AddNoteBO): Observable<any> {
    let url = "api/EmployeeNote/UpdateEmpNotes?";
    return this.http.post<any>(url, Add, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  }

  deletenote(params: URLSearchParams) {
    let url = "api/EmployeeNote/DelEmpNote?";
    return this.http.delete<any>(url + params).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }


  // TypeDropDown(): Observable<any> {

  //   let url = "api/TypeList/GetAllTypeListDropDown";

  //   return this.http.get<any>(url, { observe: 'response' }).pipe(

  //     map(data => data.body),

  //     catchError(this.errorService.handleError)

  //   )

  // }
  TypeDropDown(): Observable<any> {
    let url = "api/TypeList/GetAllTypeListDropDown";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


}